import * as type from './type';
import Vue from 'vue';
import {
  localStorage
} from '@/common/util/storage';
/* eslint-disable */
export default {
  [type.SET_USER_INFO](state, userInfo) {
    Vue.set(state, 'userInfo', localStorage.get('userInfo') ? localStorage.get('userInfo') : userInfo)
  },
  [type.SET_TOKEN](state, token) {
    Vue.set(state, 'token', localStorage.get('token') ? localStorage.get('token') : token)
  },
  [type.SET_LNG](state, lng) {
    Vue.set(state, 'lng', lng)
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations/index.js